const Immutable = require('seamless-immutable');
import ReducerContainer from '../../helper/reducer-helper';
import actionTypes from '../../consts/common-action-type';

const initialState = Immutable.from({
  errorMessage: '',
  loading: {
    status: false,
    word: '加载中',
  },
  brandInfo: {},
});

export default ReducerContainer.createReducer(initialState, {
  [actionTypes.SET_ERROR_MSG]: (state, payload) => state.set('errorMessage', payload || ''),

  [actionTypes.SET_LOAD_MSG]: (state, payload) => state.set('load', payload),

  [actionTypes.SET_BRAND_INFO]: (state, payload) => state.set('brandInfo', payload),
});



// WEBPACK FOOTER //
// ./src/reducer/common/index.js